import { Box, Typography } from "@drone-js/core";
import type { FunctionComponent } from "react";
import { useUnfinishedPropertiesValue } from "../unfinishedPropertiesAtom";
import { CardSelector } from "./CardSelector";
import { ImportOptions } from "./constants";

export const ResumeMethod: FunctionComponent = () => {
    const [firstProperty] = useUnfinishedPropertiesValue();

    return (
        <CardSelector
            id={ImportOptions.Resume}
            title={firstProperty.propertyName}
            subtitle={firstProperty.propertyLocation}
            logo={[firstProperty.mainPhotoUrl]}
            data-element-name="resume-listing-card"
            iconSize="64px"
            flexDirection="row"
            mobileIconSize="64px"
            hasMobileLeftPadding={true}
        >
            <Box mt="12">
                {firstProperty.createdWhenLabel && (
                    <Typography variant="body-default" textColor="base.subtle" data-test-id="created-when-label">
                        {firstProperty.createdWhenLabel}
                    </Typography>
                )}
            </Box>
        </CardSelector>
    );
};
